import { useTranslations } from "next-intl";
import { useTheme } from "next-themes";
import { useMemo } from "react";

import { ProfileWrapper } from "@/components/profile/ProfileWrapper";
import { getAppearanceOptions, IOption } from "@/lib/utils";

export const ThemePreference = () => {
    const t = useTranslations("theme");

    const { theme, setTheme } = useTheme();

    const appearanceOptions: IOption[] = useMemo(() => getAppearanceOptions(t), [ t ]);

    const handleAppearanceChange = (newAppearance: string) => {
        setTheme(newAppearance);
    };

    return (
        <ProfileWrapper
            headerLabel={ t("appearance") }
            currentValue={ theme }
            options={ appearanceOptions }
            onSelect={ handleAppearanceChange }
            isDialog={ true }
        />
    );
};